import React from 'react'
import {Link as RouterLink} from 'react-router-dom'
import styled from 'styled-components'
import {Trans} from 'react-i18next'
import get from 'lodash/get'
import breakpoint from 'components/breakpoint'
import {ELEMENTS_IDS} from 'const'
import {GoogleAnalyticsService} from 'services'

const LEFT_LINK_MARGIN = '4px'

const getMarginTop = props => props.theme.logisterSection.registerMarginTop
const getMarginBottom = props => props.theme.logisterSection.registerMarginBottom
const getFontSize = props => props.theme.logisterSection.registerSize || props.theme.secondaryFont.portrait.size
const getFontWeight = props => props.theme.logisterSection.registerWeight
const getFamily = props => props.theme.logisterSection.registerFamily
const getLineHeight = props => props.theme.secondaryFont.portrait.height

const getLinkHover = props => props.theme.link.default
const getHoverColor = props => props.theme.link.hoverColor
const getLinkAlign = props => props.theme.link.align || 'center'
const getFlexDirectionOnMobile = props => (props.theme.link.alignMobile === 'left' ? 'row' : 'column')
const getLinkMobileMargin = props => (getFlexDirectionOnMobile(props) === 'row' ? LEFT_LINK_MARGIN : undefined)

const getTextDecoration = props => get(props, 'theme.link.textDecoration', 'underline')
const getHoverTextDecoration = props => get(props, 'theme.link.textDecorationHover', getTextDecoration(props))

const RegisterLinkView = styled.div`
  display: flex;
  flex-direction: ${getFlexDirectionOnMobile};
  justify-content: ${getLinkAlign};
  align-items: center;
  margin-top: ${getMarginTop};
  margin-bottom: ${getMarginBottom};
  text-decoration: none;
  font-size: ${getFontSize};
  font-family: ${getFamily};
  font-weight: ${getFontWeight};
  line-height: ${getLineHeight};

  ${breakpoint('landscape')`
    flex-direction: row;
  `};

  ${breakpoint('smallMobile', 'middleMobile')`
    flex-direction: column;
  `};
`

const RegisterLink = styled(RouterLink)`
  display: inline-block;
  color: ${getLinkHover};
  text-decoration: ${getTextDecoration};
  margin-left: ${getLinkMobileMargin};

  &:hover {
    color: ${getHoverColor};
    text-decoration: ${getHoverTextDecoration};
  }

  ${breakpoint('landscape')`
    margin-left: ${LEFT_LINK_MARGIN};
  `};

  ${breakpoint('smallMobile', 'minMobile')`
    margin-left: unset;
  `};
`

const LogisterFormRegisterLink = ({getRegistrationLink}) => {
  const onLinkClickHandler = () => {
    GoogleAnalyticsService.trackRegistrationStart()
  }

  return (
    <RegisterLinkView>
      <Trans i18nKey="register.link">
        text
        <RegisterLink id={ELEMENTS_IDS.logisterPage.register} to={getRegistrationLink()} onClick={onLinkClickHandler}>
          text
        </RegisterLink>
      </Trans>
    </RegisterLinkView>
  )
}

export default LogisterFormRegisterLink
